<template>
  <div class="body">
    <van-nav-bar title="领券中心" left-text left-arrow @click-left="onClickLeft" class="topNav"/>
    <div class="content animated fadeInRight fast" v-if="hasData">
        <ItemCoupon :couponData="items" tp="coupon" v-for="(items,index) in list" :key="index" @addcoupon="addcoupon"></ItemCoupon>
    </div>
    <div v-if="!hasData">
      <NoData msg="亲，暂无优惠券哦"/>
    </div>
  </div>
</template>

<script>
import NoData from "@/components/NoData.vue";
import ItemCoupon from "@/components/ItemCoupon.vue";
import { GetCouponList,GetCoupon } from "../../apis/https.js";
import { getLocalStorage } from "../../utils/storage.js";
// import { Checkbox, CheckboxGroup } from "vant";
// import Vue from "vue";
// Vue.use(Checkbox).use(CheckboxGroup);
export default {
  components: {
    NoData,
    ItemCoupon
  },
  data() {
    return {
      hasData:false,
      list:[]
    };
  },
  created() {

  },
  activated(){
    GetCouponList(getLocalStorage("login_token")).then(res=>{
      this.list = res.data.list;
      if(res.data.list.length>0){
        this.hasData=true;
      }
    })
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    addcoupon(data){
      GetCoupon(data,getLocalStorage("login_token")).then(res=>{
        this.$toast("领取成功");
        this.$router.go(0)
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url("../../style/skin.less");
.body {
  background: #f4f8fb;
  min-height: 100vh;
  overflow: hidden;
  .topNav {
    position: fixed;
    width: 100%;
    top: 0px;
    i {
      color: #323233 !important;
    }
  }
  .content{
    margin-top: 46px;
    padding: 10px;
  }
}
</style>